// removed by extract-text-webpack-plugin
module.exports = {"StockChange":"StockChange","TotalStocks":"TotalStocks","StockChangeIcon":"StockChangeIcon","IconCenter":"IconCenter","Up":"Up","Down":"Down","Ref":"Ref"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/IndexBoard/UpDownCell/styles.scss
// module id = 2155
// module chunks = 10